import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { AnalysisTypeCreateInput } from '../generated/globalTypes';
import { createAnalysisTypeMutation, createAnalysisTypeMutationVariables } from '../generated/createAnalysisTypeMutation';
import { analysisTypeFieldsFragment } from '../models/AnalysisType';

/**
 * Get a callback to create an AnalysisType in the store.
 */
export function useCreateAnalysisTypeCallback(): [(model: AnalysisTypeCreateInput) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<createAnalysisTypeMutation, createAnalysisTypeMutationVariables>(
        gql`
            mutation createAnalysisTypeMutation ($model: AnalysisTypeCreateInput!) {
                createAnalysisType(model: $model) {
                    ...analysisTypeFields
                }
            }

            ${analysisTypeFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (model: AnalysisTypeCreateInput) => {
        const result = await mutationAction({ variables: { model: model } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
